import {
  purchaseOrdersResponseSchema,
  type PurchaseOrdersResponse,
  type POStatus,
} from '../types';
import { ApiClientError } from '@/errors';
import {
  authFetch, buildApiUrl 
} from '@/lib/api-client';

export interface POFilters {
  readonly status?: POStatus;
  readonly supplierId?: string; 
}

export async function getPurchaseOrders(filters?: POFilters): Promise<PurchaseOrdersResponse> {
  const params = new URLSearchParams();
  if (filters?.status) params.set('status', filters.status);
  if (filters?.supplierId) params.set('supplierId', filters.supplierId);

  const url = buildApiUrl('/v1/purchase-orders', params);
  const response = await authFetch(url);
  
  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch POs');
  }

  return purchaseOrdersResponseSchema.parse(await response.json());
}
